<template lang="pug">
.backdrop.fixed.inset-0.z-20(@click="close")
  transition(name="slide-fade")
    .cs-menu.w-28.h-29.absolute.z-20.text-xs.overflow-hidden(v-if="visible", :class="[position, csList.length > 4 ? 'h-43' : 'h-auto']")
      .menu-frame.w-full.h-full
        .menu-frame-inner.w-full.h-full
          .w-full.h-full.overflow-y-auto.relative.rounded-lg(v-scroll-gradient)
            ul(:class="lessThreeOptions ? 'justify-center' : ''")
              li.flex.items-center.w-full.rounded-lg.bg-linear-to-b(v-for="(cs, index) in csList", :key="`cs-${cs.name}`", :class="[index % 2 === 0 ? 'from-list-item-light-from to-list-item-light-to' : 'from-list-item-dark-from to-list-item-dark-to', index === csList.length - 1 ? '' : 'mb-1']", class="h-7.5 p-1.5", @click="showCustomerService(cs)")
                img.me-1(:src="getSocialIconUrl(cs.name)", class="w-5.5 h-5.5")
                .flex-1.truncate.text-primary-text.text-start(:class="$te(`customerService.${cs.name.toLowerCase()}`) ? '' : 'capitalize'") {{ $te(`customerService.${cs.name.toLowerCase()}`) ? $t(`customerService.${cs.name.toLowerCase()}`) : cs.name }}
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'

import { useNuxtApp } from '#app'
import { useAuthToken } from '@/composables/auth/useAuthToken'
import { useUserInfo } from '@/composables/user/useUserInfo'
import { useMainStore } from '@/stores/main'
import customerService from '@/utils/customerService'
import { isTrue } from '@/utils/siteConfigChecker'
import { useCdnAssets } from '@/composables/useCdnAssets'

const props = defineProps({
  position: {
    type: String,
    default: 'footer',
  },
})

const emit = defineEmits(['close'])

const { $analytics, $SoundControl } = useNuxtApp()
const store = useMainStore()
const { setModal, setModalParams } = store
const { userInfo } = useUserInfo({ autoInit: false })
const { isLoggedIn } = useAuthToken()
const { getSocialIconUrl } = useCdnAssets()

const visible = ref(false)

const { csChat } = useSite()

const csList = computed(() => csChat.value?.filter((item) => isTrue(item.enable)))

const lessThreeOptions = computed(() => csList.value?.length < 3)

onMounted(() => {
  visible.value = true
})

const showCustomerService = (cs) => {
  const isCustomerMessage = cs.name === 'customermessage'
  if (isCustomerMessage) {
    if (isLoggedIn.value) {
      $analytics.push({
        event: 'lobby_click',
        location: 'lobby',
        icon: 'Inbox',
      })
      setModal('ModalInbox')
      setModalParams({ tabType: 'CUSTOMER' })
    } else {
      $SoundControl.sound.play('click')
      setModal('ModalPanelLogin')
    }
  } else {
    const uid = isLoggedIn.value ? userInfo.value?.uid_site : ' '
    customerService.doAction(cs, 'setUser', uid || ' ')
    customerService.doAction(cs, 'maximize')
  }
  close()
}

const close = () => {
  visible.value = false
  emit('close')
}
</script>

<style scoped>
@reference "@/assets/css/tailwind.css";

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(50%);
  opacity: 0;
}

.cs-menu {
  &.footer {
    @apply end-2 bottom-14;
  }

  &.index {
    @apply end-6 bottom-18 lg:bottom-24 portrait:bottom-30;
  }

  ul {
    > li {
      @apply from-list-item-light-from to-list-item-light-to mb-1;

      &:nth-child(2n) {
        @apply from-list-item-dark-from to-list-item-dark-to;
      }

      &:last-child {
        @apply mb-0;
      }
    }
  }
}

.menu-frame {
  @apply rounded-2xl border-menu-field-border bg-gradient-to-b from-menu-field-from to-menu-field-to p-1;

  border-width: 0.2rem;
  border-style: solid;

  &::before {
    content: '';
    position: absolute;
    border: 0.0625rem solid #ffffffcc;
    inset: 0.125rem;
    border-radius: 0.9rem;
  }
}

.menu-frame-inner {
  @apply relative bg-gradient-to-b from-menu-bg-from to-menu-bg-to rounded-xl border-menu-bg-border text-menu-bg-border p-1;

  border-width: 0.2rem;
  border-style: solid;

  &::before {
    content: '';
    position: absolute;
    border: 0.0625rem solid #ffffff7f;
    inset: -0.125rem;
    border-radius: 0.7rem;
  }
}
</style>
